import type { Contact as CoreContact, PublicKeyEntry } from "@/core_bridge/module_api";

export type ContactSupplement = {
  deviceId?: string | null;
  appId?: string | null;
  publicKeys?: PublicKeyEntry[] | null;
};

// Canonical contact type (core Contact with local supplement fields)
export type Contact = CoreContact & ContactSupplement;
export type ContactPublicKeyEntry = PublicKeyEntry;

const isContactLike = (data: unknown): data is { userId: string } => {
  if (!data || typeof data !== "object") return false;
  const record = data as Record<string, unknown>;
  return typeof record.userId === "string" || typeof record.user_id === "string";
};

export const contactSchemaForClient = {
  parse: (data: unknown): Contact => {
    if (!isContactLike(data)) {
      throw new Error("Invalid contact payload");
    }
    const record = data as Record<string, unknown>;
    const userId = (record.userId ?? record.user_id) as string;
    const username = (record.username ?? record.user_name ?? "") as string;
    const discriminator = (record.discriminator ?? "") as string;
    return {
      ...record,
      userId,
      username,
      discriminator,
    } as Contact;
  },
  safeParse: (data: unknown) => {
    if (isContactLike(data)) {
      try {
        return { success: true as const, data: contactSchemaForClient.parse(data) };
      } catch (error) {
        return { success: false as const, error: error as Error };
      }
    }
    return { success: false as const, error: new Error("Invalid contact payload") };
  },
};
